<div class="relative min-h-screen flex flex-col">
    <!--Navbar-->
    <app-navbar></app-navbar>
    <!-- Top Banner Section Start -->
    <div class="flex-grow">
        <div class="mb-10 banner-container">
            <div class="grid grid-cols-12">
                <div class="col-span-12">
                    <div class="w-full h-[450px] banner-wrapper">
                        <img src="/assets/images/banners/contact-banner.png" alt=""
                            class="object-cover w-full h-full">
                            <div class="flex items-center h-full banner-container-inner">
                                <div class="container mx-auto">
                                    <div class="p-[30px] text-center mt-[7em]">
                                        <h1 class="my-0 mb-2 text-[2em] sm:text-5xl md:text-[2.5em] text-white">
                                            <span class="font-bold mr-2">Contact MedEase</span>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Top Banner Section End -->

        <!-- Contact Section Start -->
        <section class="contact-sec p-[1em] xxl:p-0 my-[70px] lg:my-[120px]">
            <div class="container mx-auto">
                <div class="grid grid-cols-12 items-center">
                    <div class="col-span-12 lg:col-span-8">
                        <div class="contact-left p-3 lg:p-0 mb-[70px] lg:mb-0">
                            <div class="contact-title mb-[20px] lg:mb-[50px]">
                                <span class="subtitle inline-flex text-[#45a6d1] text-[16px] mb-[10px] font-medium">Contact Us</span>
                                <h3 class="title mt-0 mb-0 lg:mb-[20px] font-bold text-[30px] md:text-[40px] lg:text-[60px] text-[#112c76] leading-[1.2em] max-w-[640px]">
                                    Get in Touch – We're Here to Help
                                </h3>
                            </div>
                            <p class="lg:w-[100%] md:max-w-[80%]">
                                At Medease, we provide round-the-clock emergency support to ensure you're never alone in critical times. Reach out to our dedicated team anytime for immediate assistance and guidance. Your health and safety are our top priority.
                            </p>
                            <div class="contact-address mt-[20px] flex flex-wrap">
                                <div class="contact-box flex items-center mr-[2em]">
                                    <div class="contact-icon inline-flex mb-[15px] w-auto h-auto flex items-center justify-center">
                                        <span class="material-symbols-outlined text-[30px] mr-[20px] text-[#45a6d1]">phone_in_talk</span>
                                    </div>
                                    <div class="contact-box-content">
                                        <div class="contact-box-description text-[14px] font-normal text-[#858585]">
                                            Our Call Service!
                                        </div>
                                        <h3 class="contact-box-title text-[#858585] text-[18px] font-normal mt-2 mb-[16px]">
                                            <a href="tel:+919446062493" class="text-[#858585]">+91 9446062493</a>
                                        </h3>
                                    </div>
                                </div>
                                <div class="contact-box flex items-center mr-[2em]">
                                    <div class="contact-icon inline-flex mb-[15px] w-auto h-auto flex items-center justify-center">
                                        <span class="material-symbols-outlined text-[30px] mr-[20px] text-[#45a6d1]">mark_email_read</span>
                                    </div>
                                    <div class="contact-box-content">
                                        <div class="contact-box-description text-[14px] font-normal text-[#858585]">
                                            Our Gmail Service!
                                        </div>
                                        <h3 class="contact-box-title text-[#858585] text-[18px] font-normal mt-2 mb-[16px]">
                                            <a href="mailto:sales@onetikk.com" class="text-[#858585]">{{ 'sales@onetikk.com' }}</a>
                                        </h3>
                                    </div>
                                </div>
                                <div class="contact-box flex items-center">
                                    <div class="contact-icon inline-flex mb-[15px] w-auto h-auto flex items-center justify-center">
                                        <span class="material-symbols-outlined text-[30px] mr-[20px] text-[#45a6d1]">pin_drop</span>
                                    </div>
                                    <div class="contact-box-content">
                                        <div class="contact-box-description text-[14px] font-normal text-[#858585]">
                                            Our Address
                                        </div>
                                        <h3 class="contact-box-title text-[#858585] text-[18px] font-normal mt-2 mb-[16px]">
                                            <a href="" class="text-[#858585]">4th Floor,CDAC Building,<br> Technopark Campus,
                                                Trivandrum, Kerala</a>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div class="social-address-container mt-[1em] inline-block">
                                <ul class="flex mt-4 items-center pl-0">
                                    <li class="list-none"><a href="https://www.facebook.com/onetikk/" target="_blank"
                                            class="text-white bg-[#45a6d1] hover:bg-[#112c76] ease-in duration-300 w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-white"><i
                                                class="fab fa-facebook-f"></i></a></li>
                                    <li class="ml-[10px] list-none"><a href="https://x.com/onetikk?lang=en" target="_blank"
                                            class="text-white border bg-[#45a6d1] hover:bg-[#112c76] ease-in duration-300 w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-white"><i
                                                class="fab fa-twitter"></i></a>
                                    </li>
                                    <li class="list-none ml-[10px]"><a href="https://www.instagram.com/accounts/login/" target="_blank"
                                            class="text-white border bg-[#45a6d1] hover:bg-[#112c76] ease-in duration-300 w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-white"><i
                                                class="fab fa-instagram"></i></a></li>
                                    <li class="ml-[10px] list-none"><a href="https://www.linkedin.com/company/onetikk/" target="_blank"
                                            class="text-white border bg-[#45a6d1] hover:bg-[#112c76] ease-in duration-300 w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-white"><i
                                                class="fab fa-linkedin"></i></a></li>
                                    <!-- <li class="ml-[10px] list-none"><a href="#"
                                            class="text-white border bg-[#45a6d1] hover:bg-[#112c76] ease-in duration-300 w-[50px] h-[50px] rounded-full flex items-center justify-center hover:text-white"><i
                                                class="fab fa-google"></i></a>
                                    </li> -->
                                </ul>
                            </div>
                        </div>
                    </div>
                    <div class="col-span-12 lg:col-span-4 p-3 lg:p-0">
                        <div class="contact-img p-[4em] rounded-[15px]">
                            <div class="contact-img-inner border border-[#ffffff45] py-[60px] px-[1em]">
                                <div class="contact-img-title">
                                    <h2 class="text-[32px] text-white text-center font-medium leading-[1.2em]">Have Any Query Feel Free Contact</h2>
                                </div>
                                <div class="contact-box flex justify-center items-center mt-[1em]">
                                    <div class="contact-icon inline-flex mb-[15px] w-auto h-auto flex items-center justify-center">
                                        <i class="fa-solid fa-phone-volume text-[52px] mr-[20px] text-[#45a6d1]"></i>
                                    </div>
                                    <div class="contact-box-content">
                                        <div class="contact-box-description text-[14px] font-normal text-white">
                                            Our Call Service!
                                        </div>
                                        <h3 class="contact-box-title text-[18px] mb-[16px] text-white">
                                            <a href="">00000012314</a>
                                        </h3>
                                    </div>
                                </div>
                            </div>
                            <div class="contact-doctor p-[1em] border border-[#ffffff45] text-center">
                                <p class="text-white">
                                    For consulting a doctor, please click the button below.
                                </p>
                                <button (click)="goToDoctorsPage()" class="w-full bg-[#45a6d1] hover:bg-[#112c76] ease-in duration-300 cursor-pointer text-white py-4 rounded footer-box">Visit Doctor</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- Contact Section End -->
    </div>

    <!-- Footer  -->
    <app-message></app-message>
    <app-footer></app-footer>
</div>